import BlockModel from '@wre/infinity-generators/SchemeOfLearning/Year1/Autumn/Shape/index';
import { newBlockContent } from '../../../Block';
import { newSmallStepContent } from '../../../SmallStep';

const Block = newBlockContent({
  block: 'Shape',
  field: 'Geometry',
  weeks: [11, 11],
  smallSteps: [
    // Step 1
    newSmallStepContent({
      ...BlockModel.smallSteps[0],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/Shape/1RecogniseAndName3DShapes" */ './1RecogniseAndName3DShapes'
        )
    }),
    // Step 2
    newSmallStepContent({
      ...BlockModel.smallSteps[1],
      module: () =>
        import(/* webpackChunkName: "Year1/Autumn/Shape/2Sort3DShapes" */ './2Sort3DShapes')
    }),
    // Step 3
    newSmallStepContent({
      ...BlockModel.smallSteps[2],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/Shape/3RecogniseAndName2DShapes" */ './3RecogniseAndName2DShapes'
        )
    }),
    // Step 4
    newSmallStepContent({
      ...BlockModel.smallSteps[3],
      module: () =>
        import(/* webpackChunkName: "Year1/Autumn/Shape/4Sort2DShapes" */ './4Sort2DShapes')
    }),
    // Step 5
    newSmallStepContent({
      ...BlockModel.smallSteps[4],
      module: () =>
        import(
          /* webpackChunkName: "Year1/Autumn/Shape/5PatternsWith2DAnd3DShapes" */ './5PatternsWith2DAnd3DShapes'
        )
    })
  ]
});
export default Block;
